module.exports = {"top3":["Children without all recommended vaccines","Hospital 30-day mortality","Uninsured children"],"bottom3":["Drug poisoning deaths","Preventable hospitalizations age 65 and older","Hospital 30-day readmission rate age 65 and older"],"most_improved":["Children without all recommended vaccines","Home health patients without improved mobility","Diabetic adults without an annual hemoglobin A1c test"],"most_declined":["Adults without all recommended vaccines","Drug poisoning deaths","Preventable hospitalizations ages 18-64"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/MA.json
// module id = 259
// module chunks = 143196823979170 184088790168614